import styled from 'styled-components';
import tw from 'twin.macro';

interface ToggleSwitchLargeProps {
  isChecked: boolean;
  onClick: () => void;
}

export const ToggleSwitchLarge = ({ isChecked, onClick }: ToggleSwitchLargeProps) => {
  return (
    <Container>
      <Label>
        <Input type={'checkbox'} className={'sr-only peer'} checked={isChecked} readOnly />
        <SwitchButton
          onClick={onClick}
          className={
            'peer peer-checked:after:translate-x-[20px] peer-checked:after:border-white after:content-[""] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:shadow-md after:border-gray-300 after:border after:rounded-full after:h-[27px] after:w-[27px] after:transition-all peer-checked:bg-[#34c759]'
          }
        />
      </Label>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;

  overflow: hidden;

  padding: 4px 0px;
`;

const Label = styled.label`
  display: inline-block;
  align-items: center;

  position: relative;

  cursor: pointer;
`;

const Input = styled.input``;

const SwitchButton = styled.div`
  width: 51px;
  height: 31px;

  background-color: rgb(229, 231, 235);

  border-radius: 9999px;

  ${tw`shadow`};
`;
